// extracted by mini-css-extract-plugin
export default {"container":"director_container__PR4to","div":"director_div__oJZ9T","img_director":"director_img_director__XsoaP","name":"director_name__SW5Kp"};